import store from 'utils/store/withMiddleware'
import { LATITUDE, VISION_ID } from 'core/constants/products'
import getById from 'utils/DOM/getById'
import toastNotification from 'pug/toastNotification'
import { ADD_PLAN, REMOVE_PLAN } from 'messages'
import handleAddons from '../controller/handleAddons'

function handleToggleAddon(): void {
  const deletePlans = !this.checked
  const id = this.id.split('-')

  const planId = +id[1]
  const addonId = +id[3]
  const state = store.getState()
  const { addonsByPlan, latitudeAddons, dentalAddons, visionAddons, plans } = state

  const latitudePlan = latitudeAddons[planId]
  const dentalPlan = dentalAddons[planId]
  const visionPlan = visionAddons[planId]

  const addons =
    plans[addonId].productId === LATITUDE ? [dentalPlan, visionPlan] : [latitudePlan]

  if (!deletePlans) {
    addons.push(addonId)
    const visionInput = getById(`vision-${planId}-addon-${addonId}`)
    if (visionInput && visionInput.checked) {
      addons.push(VISION_ID)
    }
  }

  addonsByPlan[planId] = addons.filter(Boolean)

  handleAddons({ ...state, addonsByPlan }, planId)

  toastNotification(deletePlans ? REMOVE_PLAN : ADD_PLAN)
}
export default handleToggleAddon
